<div class="table-data" [class.table-data--fixed]="isFixed()">
	<ng-content/>
</div>
